import { Suspense, lazy } from 'react';
import './App.css';
import './index.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import ProtectedRoute from './Component/ProtectedRoute';
import ScrollToTop from './Component/ScrollToTop';
import NotFound from './Component/NotFound';

// Public pages
const Home = lazy(() => import('./Component/Home/Home'));
const Login = lazy(() => import('./Login/Login'));
const Register = lazy(() => import('./Register/Register'));
const Goldprice = lazy(() => import('./Component/Goldprice'));
const Silverprice = lazy(() => import('./Component/Silverprice'));
const Contact = lazy(() => import('./Component/Contact'));
const TermsConditions = lazy(() => import('./Component/TermsConditions'));
const PrivacyPolicy = lazy(() => import('./Component/PrivacyPolicy'));
const AboutUs = lazy(() => import('./Component/AboutUs'));
const FAQ = lazy(() => import('./Component/faq'));
const Listing = lazy(() => import('./Component/Listing/Listing'));
const Productdetails = lazy(() => import('./Component/Productdetails/Productdetails'));
const ResetPassword = lazy(() => import('./ResetPassword/ResetPassword'));

// Dashboard (protected) pages
const Dashboard = lazy(() => import('./Component/Dashboard/Dashboard'));
const Profile = lazy(() => import('./Component/Dashboard/Profile'));
const Changedpassword = lazy(() => import('./Component/Dashboard/Changedpassword'));
const Listproduct = lazy(() => import('./Component/Dashboard/Listproduct'));
const Editproduct = lazy(() => import('./Component/Dashboard/Editproduct'));
const Listwishlist = lazy(() => import('./Component/Dashboard/Listwishlist'));
const ChatInbox = lazy(() => import('./Component/Dashboard/ChatInbox'));
const Sellproduct = lazy(() => import('./Component/Dashboard/Sellproduct'));

function App() {
  return (
    <div className="App">
      <Router basename="/">
        <ScrollToTop />
        <Header />
        <Suspense fallback={<div className="page-loading" style={{ minHeight: '100vh' }}></div>}>
          <Switch>
            <Route exact path="/"><Home /></Route>
            <Route exact path="/details/:id"><Productdetails /></Route>
            <Route exact path="/listing"><Listing /></Route>
            <Route exact path="/login"><Login /></Route>
            <Route exact path="/register"><Register /></Route>
            <Route exact path="/reset-password/:token"><ResetPassword /></Route>
            <Route exact path="/price"><Goldprice /></Route>
            <Route exact path="/silver-price"><Silverprice /></Route>
            <Route exact path="/contact"><Contact /></Route>
            <Route exact path="/terms-conditions"><TermsConditions /></Route>
            <Route exact path="/privacy-policy"><PrivacyPolicy /></Route>
            <Route exact path="/about-us"><AboutUs /></Route>
            <Route exact path="/faq"><FAQ /></Route>

            <ProtectedRoute path="/dashboard" component={Dashboard} />
            <ProtectedRoute path="/profile" component={Profile} />
            <ProtectedRoute path="/changed-password" component={Changedpassword} />
            <ProtectedRoute path="/sell-product" component={Sellproduct} />
            <ProtectedRoute path="/list-product" component={Listproduct} />
            <ProtectedRoute path="/edit-product/:id" component={Editproduct} />
            <ProtectedRoute path="/list-wishlist" component={Listwishlist} />
            <ProtectedRoute path="/inbox" component={ChatInbox} />

            <Route component={NotFound} />
          </Switch>
        </Suspense>
        <Footer />
      </Router>
    </div>
  );
}

export default App;